import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { DatePipe, NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, OnChanges, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@ngneat/transloco';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialogComponent } from '../notification-dialog/notification-dialog.component';



@Component({ 
    selector       : 'notifications',
    templateUrl    : './notifications.component.html',
    styleUrls    : ['./notifications.component.scss'],
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'notifications',
    standalone     : true,
    imports        : [MatButtonModule, NgIf, MatIconModule, MatTooltipModule, NgFor, NgClass, NgTemplateOutlet, CommonModule, RouterLink, DatePipe, TranslocoPipe],
})
export class NotificationsComponent implements OnInit, OnDestroy
{
    @ViewChild('notificationsOrigin') private _notificationsOrigin: MatButton;
    @ViewChild('notificationsPanel') private _notificationsPanel: TemplateRef<any>;

    //notifications: Notification[];
    notification: Notification;

    loading: boolean = false; 

    //unreadCount: number = 0;
    unreadCount: number = 0;
    notDeletedCount: number = 0;

    private _overlayRef: OverlayRef;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        public _notificationsService: NotificationsService,
        private _overlay: Overlay,
        private _viewContainerRef: ViewContainerRef,
        private _dialog: MatDialog 

    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
            this._notificationsService.unreadCount$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(count => {
                this.unreadCount = count;
                this._changeDetectorRef.markForCheck(); // Forza il rilevamento delle modifiche
            });

            this.loadNotifications();

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();

        // Dispose the overlay
        if ( this._overlayRef )
        {
            this._overlayRef.dispose();
        }
    }

    ngOnChanges(event){
        this._changeDetectorRef.detectChanges();
    }

    loadNotifications(): void {
        // Attiva lo stato di caricamento
        this.loading = true;
    
        // Recupera le notifiche
        this._notificationsService.getNofications()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((notifications: Notification[]) => {
                //this.notifications = notifications;
                this.loading = false; // Disattiva lo stato di caricamento
                this.notDeletedCount = this._notificationsService.allNotifications.length;
                //this._calculateUnreadCount();
                this._changeDetectorRef.markForCheck();
            }, () => {
                this.loading = false; // Disattiva lo stato di caricamento anche in caso di errore
            });
    }
    

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Open the notifications panel
     */

           openPanel(): void {
                // Mostra il pannello immediatamente
                if (!this._notificationsPanel || !this._notificationsOrigin) {
                    return;
                }

                if (!this._overlayRef) {
                    this._createOverlay();
                }

                this._overlayRef.attach(new TemplatePortal(this._notificationsPanel, this._viewContainerRef));

                // Recupera le notifiche
                /*this._notificationsService.getNofications()
                    .pipe(takeUntil(this._unsubscribeAll))
                    .subscribe((notifications: any) => {
                        this.notifications = notifications;
                        this.loading = false; // Disattiva lo stato di caricamento
                        this._calculateUnreadCount();
                        this._changeDetectorRef.markForCheck();
                    }, () => {
                        this.loading = false; // Disattiva lo stato di caricamento anche in caso di errore
                    });*/

                //this.loadNotifications();

            }



    /**
     * Close the notifications panel
     */
    closePanel(): void
    {
        this._overlayRef.detach();
    }

    /**
     * Mark all notifications as read
     */
    markAllAsRead(): void
    {
        // Mark all as read
        this._notificationsService.markAllAsRead().subscribe();

        this._notificationsService.unreadCount = this._notificationsService.allNotifications.flat().filter(n => !n.Read).length;
        this._changeDetectorRef.markForCheck();


    }

    deleteAll(): void {
        this._notificationsService.deleteAll().subscribe(() => {
            this._notificationsService.allNotifications = this._notificationsService.allNotifications.filter(notification => !notification.Deleted);
    
            this._notificationsService._notifications.next(this._notificationsService.allNotifications.flat());
    
            this.notDeletedCount = this._notificationsService.allNotifications.length;
            this._changeDetectorRef.markForCheck();
        });
    }
    

    /**
     * Toggle read status of the given notification
     */
    toggleRead(notification: Notification): void
    {

        // Toggle the read status
        notification.Read = !notification.Read;


        this._notificationsService.unreadCount = this._notificationsService.allNotifications.flat().filter(n => !n.Read).length;

        // Update the notification
        this._changeDetectorRef.markForCheck();

        this._notificationsService.update(notification._id, notification).subscribe();
    }

    /**
     * Delete the given notification
     */
    delete(notification: Notification): void
    {
        // Delete the notification
        notification.Deleted = true;

        this.notDeletedCount = this._notificationsService.allNotifications.flat().filter(n => !n.Deleted).length;

        this._notificationsService.update(notification._id, notification).subscribe(() => {
            this._notificationsService.allNotifications = this._notificationsService.allNotifications.filter(n => n._id !== notification._id);
            this._notificationsService._notifications.next(this._notificationsService.allNotifications.flat());
            this._changeDetectorRef.markForCheck();
        });

    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    /*trackByFn(index: number, item: any): any
    {
        return item._id || index;
    }*/

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create the overlay
     */
    private _createOverlay(): void
    {
        // Create the overlay
        this._overlayRef = this._overlay.create({
            hasBackdrop     : true,
            backdropClass   : 'fuse-backdrop-on-mobile',
            scrollStrategy  : this._overlay.scrollStrategies.block(),
            positionStrategy: this._overlay.position()
                .flexibleConnectedTo(this._notificationsOrigin._elementRef.nativeElement)
                .withLockedPosition(true)
                .withPush(true)
                .withPositions([
                    {
                        originX : 'start',
                        originY : 'bottom',
                        overlayX: 'start',
                        overlayY: 'top',
                    },
                    {
                        originX : 'start',
                        originY : 'top',
                        overlayX: 'start',
                        overlayY: 'bottom',
                    },
                    {
                        originX : 'end',
                        originY : 'bottom',
                        overlayX: 'end',
                        overlayY: 'top',
                    },
                    {
                        originX : 'end',
                        originY : 'top',
                        overlayX: 'end',
                        overlayY: 'bottom',
                    },
                ]),
        });

        // Detach the overlay from the portal on backdrop click
        this._overlayRef.backdropClick().subscribe(() =>
        {
            this._overlayRef.detach();
        });
    }

    /**
     * Calculate the unread count
     *
     * @private
     */
    /*private _calculateUnreadCount(): void
    {
        let count = 0;

        if ( this._notificationsService.allNotifications.flat() && this._notificationsService.allNotifications.length )
        {
            count = this._notificationsService.allNotifications.flat().filter(notification => !notification.Read).length;
        }

        this._notificationsService.unreadCount = count;
    }*/

    viewNotification(notification: Notification): void {
        if (!notification.Read) {
            notification.Read = true;
    
            this._notificationsService.update(notification._id, notification).subscribe(() => {
                this._notificationsService.unreadCount = this._notificationsService.allNotifications.flat().filter(n => !n.Read).length;
                this._changeDetectorRef.markForCheck();
            });
        }
    
        this.openNotificationModal(notification);
    }

    openNotificationModal(notification: Notification): void {
        const dialogRef = this._dialog.open(NotificationDialogComponent, {
            width: '600px',
            data: { notification }
        });
    
        dialogRef.afterClosed().subscribe(() => {
            console.log('Dialog chiuso');
        });
    }
    
    
    
    
    
}
